<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import page--article-form


</style>
<script>
    import Newsfeed from '../../common/components/Newsfeed.vue'

    export default {
        components: {
            Newsfeed
        }
    }

</script>

